import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: { isPending: false, isSuccessful: false, isFailure: false },
  warnings: [],
};

function handleRequest(state: State): State {
  return { ...state, request: setRequestStateToPending() };
}

function handleSuccess(
  state: State,
  { warnings }: Boundaries["checkAllocationWarnings"]["success"],
): State {
  return { warnings, request: setRequestStateToSuccess() };
}

function handleFailure(state: State): State {
  return { ...state, request: setRequestStateToFailure() };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.checkAllocationWarningsRequested]: handleRequest,
    [events.checkAllocationWarningsSucceeded]: handleSuccess,
    [events.checkAllocationWarningsFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };
export { reduceState, initialState, createSelector };
